import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f3d80a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DataProcessing" }
const _hoisted_2 = { class: "center-dropdown-table-container" }
const _hoisted_3 = {
  class: "center-dropdown-table",
  style: {"margin-top":"0px"}
}
const _hoisted_4 = { class: "center-buttons bottom-margin-only" }
const _hoisted_5 = ["disabled", "title"]
const _hoisted_6 = { class: "center-buttons bottom-margin-only" }
const _hoisted_7 = ["disabled", "title"]
const _hoisted_8 = {
  key: 0,
  class: "content-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "content-container"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "description-title" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"red"} }, "Error Viewing Source File:", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { style: {"text-align":"center"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-title" }, "Loading Error", -1))
const _hoisted_24 = { class: "description-subtitle" }
const _hoisted_25 = { style: {"margin-bottom":"20px","padding":"20px"} }
const _hoisted_26 = { style: {"text-align":"center"} }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "description-title" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"red"} }, "Error Viewing Table Data:", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { style: {"text-align":"center"} }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-title" }, " Warning ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-subtitle" }, " You are about to delete the following staging entries: ", -1))
const _hoisted_40 = { style: {"text-align":"center"} }
const _hoisted_41 = { class: "top-content" }
const _hoisted_42 = { class: "flex-row-centered" }
const _hoisted_43 = { class: "flex-col-centered" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "File Type Selection:", -1))
const _hoisted_45 = ["value"]
const _hoisted_46 = ["title", "disabled"]
const _hoisted_47 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_48 = { style: {"font-size":"120%","font-weight":"bold"} }
const _hoisted_49 = { class: "FileNameDisplay" }
const _hoisted_50 = { class: "FileNameDisplay" }
const _hoisted_51 = { class: "FileNameDisplay" }
const _hoisted_52 = {
  key: 5,
  id: "details-view",
  class: "table-container"
}
const _hoisted_53 = { class: "details-column" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details-column-title" }, "Waiting Files", -1))
const _hoisted_55 = ["onClick", "disabled", "title"]
const _hoisted_56 = { class: "details-column" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details-column-title" }, "Processed Files", -1))
const _hoisted_58 = ["onClick", "disabled", "title"]
const _hoisted_59 = { class: "details-column" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details-column-title" }, "Failed Files", -1))
const _hoisted_61 = ["onClick", "disabled", "title"]
const _hoisted_62 = { style: {"display":"flex"} }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { style: {"display":"flex"} }
const _hoisted_65 = ["onClick"]

import { onMounted, inject, ref, computed, onUnmounted, watch } from "vue";
// Services
import { apiLoggerKey } from "@/types/ServiceKeys";
import {
    colsLastReceivedFilesByType,
    labelsLastReceivedFilesByType,
    colsStagingEntry,
    labelsStagingEntry,
    colsFileDetails,
    labelsFileDetails,
    ParseItems,
    DataHelperServices,
} from "@/services/helpers/DataProcessingHelper";
// Data
import { LastReceivedFilesByType, LastReceivedFilesByTypeDataItem } from "@/models/LastReceivedFilesByType";
import { defaultMarket, marketSelection } from "@/services/helpers/Helper";
import { FileType, fileTypes } from "@/Interfaces/IFileTypes";
// Table
import Table, { ITableExpose } from "@/components/TablePersistentChecking.vue";
// Misc
import log from "loglevel";
import { AxiosError } from "axios";
import { StagingEntries, StagingEntry } from "@/models/StagingEntries";
import { StagingDataRequest } from "@/models/StagingDataRequest";
import { SFTPFileStatuses } from "@/models/LastReceivedFilesByType";
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import MarketSelector from "@/components/MarketSelector.vue";
import { FileDetails, LastReceivedFilesDetails } from "@/models/LastReceivedFileDetails";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

const fileName = "DataProcessing.vue";
const sortCol: keyof LastReceivedFilesByTypeDataItem = 'FileType';

export default /*#__PURE__*/_defineComponent({
  __name: 'DataProcessing',
  setup(__props) {

const Logger = inject(apiLoggerKey);

document.title = 'Data Processing - UV';

// MISC
const DPServices = new DataHelperServices();

//SELECTORS
const localFileTypes = ref<FileType[]>([...fileTypes]);
const fileTypeSelection = ref("ALL_FILE_TYPES");

// VIEWS
const showFileView = ref(true);
const showFileDetailsView = ref(false);
const showStagingView = ref(false);

// LAST RECEIVED FILES
const lastReceivedSFTPFiles = ref<LastReceivedFilesByType>();
const displayedLastReceivedSFTPFiles = ref<LastReceivedFilesByTypeDataItem[]>();
const lastReceivedFilesDetails = ref<LastReceivedFilesDetails>();
const processedLastReceivedFilesDetails= ref<FileDetails[]>();
const waitingLastReceivedFilesDetails= ref<FileDetails[]>();
const failedLastReceivedFilesDetails= ref<FileDetails[]>();

//STAGING TABLE
const stagingViewTable = ref<ITableExpose<StagingEntry>>();
const stagingEntries= ref<StagingEntry[]>();
const displayedStagingEntries= computed(()=>
    fileTypeSelection.value === "ALL_FILE_TYPES" ? 
        stagingEntries.value : 
        stagingEntries.value?.filter((x) => x.FileType === fileTypeSelection.value)
);

// VIEW SOURCE FILES
const sourceFileDisplayName = ref<string>();
const showSourceFilePopup = ref(false);
const sourceFile = ref();

// WIEW LOADING ERROR
const showLoadingErrorPopup = ref(false);
const loadingErrorDisplayName = ref<string>();
const loadingError = ref();

// VIEW TABLE DATA
const showTableDataPopup = ref(false);
const tableDataDisplayName = ref<string>();
const tableDataDisplaySubName = ref<string>();
const tableData = ref();

// DELETE STAGING ENTRIES
const showStagingDeletePopup = ref(false);
const confirmStagingDeletion = ref(false);
const stagingDeleteData = ref<string>();

// LOADING STATUS
const isLoading = ref(false);
const isSourceFileLoading = ref(false);
const isTableDataLoading = ref(false);

// ERROR
const showTableDataError = ref(false);
const showSourceFileError = ref(false);
const fileError = ref(false);
const infoError = ref(false);
const errorDescription = ref<string>();

// TABLE
const defaultSortCols = ref([colsLastReceivedFilesByType.findIndex(col => col === sortCol)]);
const defaultSortOrders = ref<(1|-1)[]>([1]);
    
onMounted(async () => {
    log.debug("onMounted() Data Processing");
    const newFileType = new FileType("ALL_FILE_TYPES", "AllFileTypes", "All File Types");
    localFileTypes.value.unshift(newFileType);
    marketSelection.value = defaultMarket
    await GetLastReceivedSFTPFiles(marketSelection.value);
});

onUnmounted(() => {
    marketSelection.value = 'GB'
})

function toSentenceCase(text: string): string {
    return text.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');                            // join with spaces
}
async function GetLastReceivedSFTPFiles(market: string) {
    log.trace("GetLastReceivedSFTPFiles()");
    fileError.value = false;
    const name = GetLastReceivedSFTPFiles.name;
    const Class = fileName + "/" + name;
    var Message = `Getting last received ${marketSelection.value} files for all types`;
    try {
        infoError.value = false;
        displayedLastReceivedSFTPFiles.value = undefined;
        const response = await DPServices.GetLastReceivedSFTPFiles(market);
        lastReceivedSFTPFiles.value = ParseItems(response);

        displayedLastReceivedSFTPFiles.value = lastReceivedSFTPFiles.value.GetData();

        log.debug(
            `GetLastReceivedSFTPFiles()\ndisplayedLastReceivedSFTPFiles: (${
                displayedLastReceivedSFTPFiles.value.length
            }) ${JSON.stringify(displayedLastReceivedSFTPFiles.value)}`
        );

        log.trace(
            `GetLastReceivedSFTPFiles()\nresponse: ${JSON.stringify(
                lastReceivedSFTPFiles.value
            )}`
        );

        Logger?.LogInformation(Message, Class);
    } catch (error) {
        fileError.value = true;
        useNotifierWithErrFormatter().error({error, errorType:"Getting Last Received " + marketSelection.value + " Files for All Types"})
        const Message = `Error retrieving last received ${marketSelection.value} files for all types: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}
async function GetLastReceivedSFTPFilesDetails(market: string, fileType: string) {
    const name = GetLastReceivedSFTPFilesDetails.name;
    const Class = fileName + "/" + name;
    var Message = `Getting Last Received SFTP file details (market: ${market}, fileType: ${fileType})`;

    log.trace(`${name}()\n${Message}`);
    fileError.value = false;
    isLoading.value = true;

    fileTypes.forEach((fileType) => {
        sessionStorage.removeItem(fileType.ID);
    });

    try {
        const data = await DPServices.GetLastReceivedSFTPFilesDetails(market, fileType);
        //const data = (await lastReceivedFileDetails.get()).data;
        lastReceivedFilesDetails.value = new LastReceivedFilesDetails(data);

        waitingLastReceivedFilesDetails.value = lastReceivedFilesDetails.value.Waiting;
        processedLastReceivedFilesDetails.value = lastReceivedFilesDetails.value.Processed;
        failedLastReceivedFilesDetails.value = lastReceivedFilesDetails.value.Failed;

    } catch(error) {
        fileError.value = true;
        useNotifierWithErrFormatter().error({error, errorType: "Getting Last Received " + marketSelection.value +  " Files of Type " + toSentenceCase(fileTypeSelection.value)})
        Message = `(Error) ${Message}: ${error}.`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}
async function GetStagingEntries(market: string){
    const name = GetStagingEntries.name;
    const Class = fileName + "/" + name;
    var Message = `Getting Staging Entries (market: ${market})`;

    try {
        stagingEntries.value = undefined;
        ResetErrors();
        const response = await DPServices.GetStagingEntries(market);
        stagingEntries.value = response;
    } catch(error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting Staging Entries for " + marketSelection.value })
        Message = `(Error) ${Message}: ${error}.`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}
async function ViewTableData(stagingEntry: StagingEntry) {
    const name = ViewTableData.name;
    const Class = fileName + "/" + name;
    var Message = `Getting Staging Data (staging entry: ${stagingEntry})`;

    isTableDataLoading.value = true;
    showTableDataPopup.value = true;

    const stagingDataRequest: StagingDataRequest = {
        SourceFileReference: stagingEntry.SourceFileReference,
        TableType: stagingEntry.TableType,
        LoadingSequence: stagingEntry.LoadingSequence.toString(),
    };

    await DPServices.GetStagingData(stagingDataRequest)
        .then((response: string) => {
            try{
                tableData.value = JSON.stringify(JSON.parse(response), null, 6);
            }
            catch{
                tableData.value = response;
            }
            tableDataDisplayName.value = stagingEntry.SourceFileReference;
            tableDataDisplaySubName.value = "Table: " + stagingEntry.TableType.replace("Table", "") + "   |   " +"Loading Seq: " + stagingEntry.LoadingSequence;
            log.trace(
                `GetStagingData()\n Response: ${JSON.stringify(
                    response
                )}`
            );
            isTableDataLoading.value = false;
        })
        .catch((error: any) => {
            showTableDataError.value = true;
            isTableDataLoading.value = false;
            if (error instanceof AxiosError) {
                tableData.value = `{"ERROR":{"Info":"Error Table Data. "Details":"${error}","Status":"${error.response?.status}, ${error.response?.statusText}","Message":"Your request could not be fulfilled at this moment due to a server-side error, please try again later. If this error persists, please raise a ticket with the help desk."}}`
                showTableDataPopup.value = true;
            }
            Message = `(Error) ${Message}: ${error instanceof AxiosError ? error : error.message}.`;
            log.error(Message);
            Logger?.LogError(Message, Class);
        });
}
function PreDeleteStagingEntryWarning(stagingEntries: StagingEntry[]){
    log.trace("PreDeleteStagingEntryWarning()");

    if (stagingEntries.length === 0){
        return;
    }

    stagingDeleteData.value = JSON.stringify(stagingEntries, null, 6);
    confirmStagingDeletion.value = false;
    showStagingDeletePopup.value = true;
    isLoading.value = false;

}
async function DeleteStagingEntries(stagingEntries: StagingEntry[]){
    const name = DeleteStagingEntries.name;
    const Class = fileName + "/" + name;
    var Message = `Deleting Staging Entries (staging entries: ${stagingEntries})`;

    showStagingDeletePopup.value = false;
    
    infoError.value = false;
    isLoading.value = true;

    const stagingEntriesBody : StagingEntries =  {
        StagingEntries: stagingEntries
    }
    try {
        const response = await DPServices.DeleteStagingEntries(stagingEntriesBody);
        log.trace(
            `DeleteStagingEntries()\n Response: ${JSON.stringify(
                response
            )}`
        );       
        await GetStagingEntries(marketSelection.value);
        stagingViewTable.value?.ClearChecked();
    } catch(error) {
        infoError.value = true;
        useNotifierWithErrFormatter().error({error, errorType: "Deleting Staging Entries for " + JSON.stringify(stagingEntries, null)})
        Message = `(Error) ${Message}: ${error}.`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}
async function ViewSourceFile(market: string, fileType: string, status: string, sourceFileName: string, createdOn?: Date) {
    const name = ViewSourceFile.name;
    const Message = `Viewing source file: ${sourceFileName} (market: ${market}, file type: ${fileType}).`;
    const Class = fileName + "/" + name;

    log.trace(`${name}()\n${Message}`);
    sourceFileDisplayName.value = sourceFileName;
    showSourceFileError.value = false;
    showSourceFilePopup.value = true;
    isSourceFileLoading.value = true;

    Logger?.LogInformation(Message, Class);
    if (fileTypeSelection.value in sessionStorage) {
        log.debug(
            `ViewSourceFile()\nChecking session storage for ${fileTypeSelection.value} ${fileName}`
        );

        const cacheItem: any = JSON.parse(sessionStorage.getItem(fileTypeSelection.value)!);

        if (sourceFileName in cacheItem) {
            log.debug(
                `ViewSourceFile()\nLoading ${fileTypeSelection.value} ${fileName} source file from session storage`
            );
            const sourceFile: any = cacheItem[sourceFileName];
            try {
                DisplaySourceFile(sourceFile);
            }
            catch {
                DisplaySourceFile(sourceFile, false);
            }
        } else {
            log.debug(
                `ViewSourceFile()\n${fileTypeSelection.value} ${fileName} not in session storage`
            );
            await GetSourceFileAndHandleErrors(Class, Message, market, fileType, status, sourceFileName, createdOn);
        }
    } else {
        await GetSourceFileAndHandleErrors(Class, Message, market, fileType, status, sourceFileName, createdOn);
    }
    isSourceFileLoading.value = false;
}
async function GetSourceFileAndHandleErrors(Class: string, Message: string, market: string, fileType: string, status: string, sourceFileName: string, createdOn?: Date) {
    log.debug(
        `ViewSourceFile()\nLoading ${fileTypeSelection.value} source file from API`
    );
    await DPServices.GetSourceFile(fileType, status, sourceFileName, createdOn)
        .then((data: any) => {
            try {
                DisplaySourceFile(data);
            }
            catch {
                DisplaySourceFile(data, false);
            }
            CacheSourceFile(sourceFileName, data);

            Logger?.LogInformation(Message, Class);
        })
        .catch((error: any) => {
            showSourceFileError.value = true;
            isLoading.value = false;

            if (error instanceof AxiosError) {
                DisplaySourceFile(
                    `{"ERROR":{"Info":"Error viewing source file: ${sourceFileName}","File type":"${fileType}","Details":"${error}","Status":"${error.response?.status}, ${error.response?.statusText}","Message":"Your request could not be fulfilled at this moment due to a server-side error, please try again later. If this error persists, please raise a ticket with the help desk."}}`
                );
                Message = `(Error) ${Message}: ${error}.`;
            } else {
                DisplaySourceFile(error, false);
                Message = `(Error) ${Message}: ${error.message}.`;
            }
            log.error(Message);
            Logger?.LogError(Message, Class);
        });
}
function DisplaySourceFile(fileContents: string, jsonFile: boolean=true) {
    log.trace("DisplaySourceFile()\nfileContents:", fileContents);
    sourceFile.value = jsonFile
        ? JSON.stringify(JSON.parse(fileContents), null, 6)
        : "<div style='color: red'>INVALID FILE:<br>This file is not properly JSON formatted.</div><br>" + fileContents;
}
function ViewLoadingError(stagingEntry: StagingEntry) {

    log.trace(`ViewLoadingError()`);
    loadingErrorDisplayName.value = stagingEntry.SourceFileReference      ;
    showLoadingErrorPopup.value = true;

    loadingError.value = stagingEntry.LoadingError;
}
function CacheSourceFile(sourceFileName: string, fileContents?: string) {
    log.trace("CacheSourceFile()");
    const cacheItem: any = fileTypeSelection.value in sessionStorage
        ? JSON.parse(sessionStorage.getItem(fileTypeSelection.value)!)
        : {};
    cacheItem[sourceFileName] = fileContents;
    sessionStorage.setItem(fileTypeSelection.value, JSON.stringify(cacheItem));
}
function LastReceivedFilesRowClicked(row: LastReceivedFilesByTypeDataItem) {
    log.trace("LastReceivedFilesRowClicked()");


    fileTypeSelection.value = localFileTypes.value.find((fileType) => fileType.APIName === row.FileType)!.ID;

    showFileView.value = (fileTypeSelection.value === "ALL_FILE_TYPES");
    showFileDetailsView.value = !(fileTypeSelection.value === "ALL_FILE_TYPES");
    showStagingView.value = false;

    GetLastReceivedSFTPFilesDetails(marketSelection.value, fileTypeSelection.value);
}
async function updateMarketSelection() {
    log.trace("updateMarketSelection()");
    log.debug("Market selection changed");

    const name = updateMarketSelection.name;
    const Message = `Changed selection to: market: ${marketSelection.value}.`;
    const Class = fileName + "/" + name;

    ResetErrors();

    if (showFileView.value) {
        await GetLastReceivedSFTPFiles(marketSelection.value);
    }
    else if (showFileDetailsView.value){
        await GetLastReceivedSFTPFilesDetails(marketSelection.value, fileTypeSelection.value);
    } 
    else if (showStagingView.value) {
        await GetStagingEntries(marketSelection.value);
    }

    Logger?.LogInformation(Message, Class);
}
async function updateFileTypeSelection() {
    log.trace("updateFileTypeSelection()");
    log.debug("File Type selection changed");

    const name = updateFileTypeSelection.name;
    const Message = `Changed selection to: fileType: ${fileTypeSelection.value}.`;
    const Class = fileName + "/" + name;

    // Fetch Data
    if (showFileView.value || showFileDetailsView.value) {

        ResetErrors();

        showFileView.value = (fileTypeSelection.value === "ALL_FILE_TYPES");
        showFileDetailsView.value = !(fileTypeSelection.value === "ALL_FILE_TYPES");

        if (showFileView.value) {
            await GetLastReceivedSFTPFiles(marketSelection.value);
        }
        else {
            await GetLastReceivedSFTPFilesDetails(marketSelection.value, fileTypeSelection.value);
        } 
    }
    Logger?.LogInformation(Message, Class);
}
async function HandleFileViewClick() {
    log.trace("HandleFileViewClick()");
    log.debug("File View Clicked");

    ResetErrors();

    showFileView.value = (fileTypeSelection.value === "ALL_FILE_TYPES");
    showFileDetailsView.value = !(fileTypeSelection.value === "ALL_FILE_TYPES");  
    showStagingView.value = false;

    if (showFileView.value) {
      await GetLastReceivedSFTPFiles(marketSelection.value);
    }
    else {
      await GetLastReceivedSFTPFilesDetails(marketSelection.value, fileTypeSelection.value);
    }
}
async function HandleStagingViewClick() {
    log.trace("HandleStagingViewClick()");
    log.debug("Staging View Clicked");

    showFileView.value = false;
    showFileDetailsView.value = false;  
    showStagingView.value = true;

    await GetStagingEntries(marketSelection.value);
}
function ResetErrors(){
    showSourceFileError.value = false;
    showTableDataError.value = false;
    fileError.value = false;
    infoError.value = false;
    errorDescription.value = undefined;
}
function FormatLoadingError(loadingError: string) {
    log.trace("FormatLoadingError()");
    log.debug("Formatting Loading Error");

    if (loadingError === undefined || loadingError === null) {
        return loadingError;
    }
    
    if (loadingError.includes("conflicted with the FOREIGN KEY constraint")) {

        const fkConstraintMatch = loadingError.match(/FOREIGN KEY constraint "(.*?)"/);
        const tableMatch = loadingError.match(/(\w+Table) {([^}]+)}/); 
        const addedFkMatch = loadingError.match(/Added FK {([^}]+)}/);
        
        if (!fkConstraintMatch || !tableMatch || !addedFkMatch){    
            return loadingError;
        }
        else{
            const fkConstraint = fkConstraintMatch[1];
            const tableName = tableMatch[1];
            const tableInfo = tableMatch[2];
            const addedFkInfo = addedFkMatch[1];
            return `Foreign Key Conflict: ${fkConstraint} on ${tableName} {${tableInfo}} Added FK {${addedFkInfo}}`;
        }
    }
    else{
        return loadingError;
    }
}
const backButtonFileViewAction = computed(() => {
    return fileTypeSelection.value != "ALL_FILE_TYPES" && showStagingView.value == false
});
watch(backButtonFileViewAction, (newValue, oldValue) => {
    if(newValue == true){
        // this prevents back button default action
        window.history.pushState(null, "", window.location.href); 
        //this is to detect that back button was pressed and replaces its default action with a custom action
        window.addEventListener('popstate', () => {
            fileTypeSelection.value = "ALL_FILE_TYPES"
            updateFileTypeSelection();
        });
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: _normalizeClass(`button-left ${showFileView.value || showFileDetailsView.value ? 'selected' : 'unselected'}`),
                  style: {"width":"100%"},
                  disabled: showFileView.value || showFileDetailsView.value,
                  title: showFileView.value || showFileDetailsView.value ? 'Currently in File View' : 'Click to switch to Staging View',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (HandleFileViewClick()))
                }, " File View ", 10, _hoisted_5)
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: _normalizeClass(`button-right ${showStagingView.value ? 'selected' : 'unselected'}`),
                  style: {"width":"100%"},
                  disabled: showStagingView.value,
                  title: showStagingView.value ? 'Currently Staging View' : 'Click to switch to File View',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (HandleStagingViewClick()))
                }, " Staging View ", 10, _hoisted_7)
              ])
            ])
          ])
        ])
      ])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (showSourceFilePopup.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showSourceFilePopup.value = false)),
                title: "Click outside of popup to close source file.",
                class: "overlay"
              }, [
                (isSourceFileLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                      class: "popup"
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        (showSourceFileError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                          : (_openBlock(), _createElementBlock("div", _hoisted_19, "Source File:"))
                      ]),
                      _createElementVNode("div", {
                        class: "description-subtitle",
                        style: _normalizeStyle(showSourceFileError.value ? 'color: red' : '')
                      }, [
                        _createTextVNode(_toDisplayString(sourceFileDisplayName.value) + " ", 1),
                        _hoisted_20,
                        _createTextVNode(" (" + _toDisplayString(_unref(fileTypes).find((fileType) => fileType.ID === fileTypeSelection.value)
                                ?.DisplayName) + ") ", 1)
                      ], 4),
                      _createElementVNode("pre", {
                        innerHTML: sourceFile.value,
                        style: _normalizeStyle(showSourceFileError.value ? 'color: red' : '')
                      }, null, 12, _hoisted_21),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (showSourceFilePopup.value = false)),
                          title: "Close source file. (You can also click outside the popup to close source file.)"
                        }, " Close ")
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true),
          (showLoadingErrorPopup.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (showLoadingErrorPopup.value = false)),
                title: "Click outside of popup to close loading error.",
                class: "overlay"
              }, [
                _createElementVNode("div", {
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                  class: "popup"
                }, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(loadingErrorDisplayName.value), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(loadingError.value), 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showLoadingErrorPopup.value = false)),
                      title: "Close loading error. (You can also click outside the popup to close loading error.)"
                    }, " Close ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (showTableDataPopup.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (showTableDataPopup.value = false)),
                title: "Click outside of popup to close table data.",
                class: "overlay"
              }, [
                (isTableDataLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                      class: "popup"
                    }, [
                      _createElementVNode("div", _hoisted_30, [
                        (showTableDataError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, "Table Data"))
                      ]),
                      _createElementVNode("div", {
                        class: "description-subtitle",
                        style: _normalizeStyle(showTableDataError.value ? 'color: red' : '')
                      }, [
                        _createTextVNode(_toDisplayString(tableDataDisplayName.value) + " ", 1),
                        _hoisted_35,
                        _createTextVNode(" " + _toDisplayString(tableDataDisplaySubName.value), 1)
                      ], 4),
                      _createElementVNode("pre", {
                        innerHTML: tableData.value,
                        style: _normalizeStyle(showTableDataError.value ? 'color: red' : '')
                      }, null, 12, _hoisted_36),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("button", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (showTableDataPopup.value = false)),
                          title: "Close table data. (You can also click outside the popup to close table data.)"
                        }, " Close ")
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true),
          (showStagingDeletePopup.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                onClick: _cache[13] || (_cache[13] = ($event: any) => (showStagingDeletePopup.value = false)),
                title: "Click outside of popup to close.",
                class: "overlay"
              }, [
                _createElementVNode("div", {
                  onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                  class: "popup"
                }, [
                  _hoisted_38,
                  _hoisted_39,
                  _createElementVNode("pre", null, _toDisplayString(stagingDeleteData.value), 1),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("button", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (DeleteStagingEntries(stagingViewTable.value?.GetChecked()??[]))),
                      title: "Delete Staging Entries"
                    }, " Confirm Deletion ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createVNode(MarketSelector, {
                enableSE: "",
                onChange: updateMarketSelection
              }),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((fileTypeSelection).value = $event)),
                  onChange: updateFileTypeSelection,
                  class: "dropdown"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localFileTypes.value, (fileType) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: fileType.ID,
                      key: fileType.ID
                    }, _toDisplayString(fileType.DisplayName), 9, _hoisted_45))
                  }), 128))
                ], 544), [
                  [_vModelSelect, fileTypeSelection.value]
                ])
              ]),
              _createElementVNode("button", {
                class: _normalizeClass(['centre-button', 'center-buttons-button-disabled', { hidden:!showStagingView.value }]),
                style: {"width":"10rem","font-size":"1rem","padding":"0.4rem"},
                title: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).DeleteStagingEntries) ? `Delete Staging Entries (Access Denied)` : `Delete Staging Entries`,
                onClick: _cache[15] || (_cache[15] = ($event: any) => (PreDeleteStagingEntryWarning(stagingViewTable.value?.GetChecked() ?? []))),
                disabled: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).DeleteStagingEntries)
              }, " Delete Entries ", 10, _hoisted_46)
            ])
          ]),
          (showFileView.value)
            ? (_openBlock(), _createBlock(Table, {
                key: 4,
                Rows: displayedLastReceivedSFTPFiles.value,
                Cols: _unref(colsLastReceivedFilesByType),
                Labels: _unref(labelsLastReceivedFilesByType),
                DefaultSortCols: defaultSortCols.value,
                DefaultSortOrders: defaultSortOrders.value,
                RowClickedCallBack: LastReceivedFilesRowClicked,
                HasError: fileError.value
              }, {
                FileType: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(fileTypes).find((x) => x.APIName === props.value.FileType)?.DisplayName), 1)
                  ])
                ]),
                WaitingName: _withCtx((props) => [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(props.value.WaitingName), 1)
                ]),
                ProcessedName: _withCtx((props) => [
                  _createElementVNode("span", _hoisted_50, _toDisplayString(props.value.ProcessedName), 1)
                ]),
                FailedName: _withCtx((props) => [
                  _createElementVNode("span", _hoisted_51, _toDisplayString(props.value.FailedName), 1)
                ]),
                _: 1
              }, 8, ["Rows", "Cols", "Labels", "DefaultSortCols", "DefaultSortOrders", "HasError"]))
            : _createCommentVNode("", true),
          (showFileDetailsView.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createVNode(Table, {
                    Rows: waitingLastReceivedFilesDetails.value,
                    Cols: _unref(colsFileDetails),
                    Labels: _unref(labelsFileDetails),
                    HasError: infoError.value,
                    MiniPaging: ""
                  }, {
                    Name: _withCtx(({value}) => [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (
                                    ViewSourceFile(
                                        _unref(marketSelection),
                                        fileTypeSelection.value,
                                        _unref(SFTPFileStatuses)[_unref(SFTPFileStatuses).Waiting],
                                        value.Name
                                    )
                                ),
                        disabled: 
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                ,
                        title: 
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                        ? 'Cannot view ' +
                                        _unref(fileTypes).find(
                                            (fileType) => fileType.ID === 'CUSTOMER'
                                        )?.DisplayName +
                                        ' files'
                                        : 'View source file'
                                ,
                        class: _normalizeClass([
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                        ? 'text-link-denied'
                                        : 'fake-link'
                                    , 'filename'
                                ])
                      }, _toDisplayString(value.Name.replaceAll('_','_​')), 11, _hoisted_55)
                    ]),
                    _: 1
                  }, 8, ["Rows", "Cols", "Labels", "HasError"])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createVNode(Table, {
                    Rows: processedLastReceivedFilesDetails.value,
                    Cols: _unref(colsFileDetails),
                    Labels: _unref(labelsFileDetails),
                    HasError: infoError.value,
                    MiniPaging: ""
                  }, {
                    Name: _withCtx(({value}) => [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (
                                    ViewSourceFile(
                                        _unref(marketSelection),
                                        fileTypeSelection.value,
                                        _unref(SFTPFileStatuses)[_unref(SFTPFileStatuses).Processed],
                                        value.Name
                                    )
                                ),
                        disabled: 
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                ,
                        title: 
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                        ? 'Cannot view ' +
                                        _unref(fileTypes).find(
                                            (fileType) => fileType.ID === 'CUSTOMER'
                                        )?.DisplayName +
                                        ' files'
                                        : 'View source file'
                                ,
                        class: _normalizeClass([
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                        ? 'text-link-denied'
                                        : 'fake-link'
                                    , 'filename'
                                ])
                      }, _toDisplayString(value.Name.replaceAll('_','_​')), 11, _hoisted_58)
                    ]),
                    _: 1
                  }, 8, ["Rows", "Cols", "Labels", "HasError"])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode(Table, {
                    Rows: failedLastReceivedFilesDetails.value,
                    Cols: _unref(colsFileDetails),
                    Labels: _unref(labelsFileDetails),
                    HasError: infoError.value,
                    MiniPaging: ""
                  }, {
                    Name: _withCtx(({value}) => [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (
                                    ViewSourceFile(
                                        _unref(marketSelection),
                                        fileTypeSelection.value,
                                        _unref(SFTPFileStatuses)[_unref(SFTPFileStatuses).Failed],
                                        value.Name
                                    )
                                ),
                        disabled: 
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                ,
                        title: 
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                        ? 'Cannot view ' +
                                        _unref(fileTypes).find(
                                            (fileType) => fileType.ID === 'CUSTOMER'
                                        )?.DisplayName +
                                        ' files'
                                        : 'View source file'
                                ,
                        class: _normalizeClass([
                                    fileTypeSelection.value ===
                                    _unref(fileTypes).find((fileType) => fileType.ID === 'CUSTOMER')
                                        ?.ID
                                        ? 'text-link-denied'
                                        : 'fake-link'
                                    , 'filename'
                                ])
                      }, _toDisplayString(value.Name.replaceAll('_','_​')), 11, _hoisted_61)
                    ]),
                    _: 1
                  }, 8, ["Rows", "Cols", "Labels", "HasError"])
                ])
              ]))
            : _createCommentVNode("", true),
          (showStagingView.value)
            ? (_openBlock(), _createBlock(Table, {
                key: 6,
                ref_key: "stagingViewTable",
                ref: stagingViewTable,
                Rows: displayedStagingEntries.value,
                Cols: _unref(colsStagingEntry),
                Labels: _unref(labelsStagingEntry),
                HasCheckBox: "",
                HasError: infoError.value
              }, {
                TableType: _withCtx((props) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(props.value.TableType.replace("Table","")), 1)
                  ])
                ]),
                LoadingError: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("button", {
                      class: "overflow-text",
                      onClick: ($event: any) => (ViewLoadingError(props.value)),
                      title: `View Full Loading Error in Popup`
                    }, _toDisplayString(FormatLoadingError(props.value.LoadingError)), 9, _hoisted_63)
                  ])
                ]),
                TableData: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (ViewTableData(props.value)),
                      class: "table-button",
                      title: `View Table Data in Popup`,
                      style: {"flex-grow":"1","flex-shrink":"0"}
                    }, " View Data ", 8, _hoisted_65)
                  ])
                ]),
                _: 1
              }, 8, ["Rows", "Cols", "Labels", "HasError"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})